// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale, { scaleInverse } from "../helper/scaling";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  @media (max-width: 700px) {
    margin: 0 23px;
    width: calc(100% - 46px);
  }
`;

class SetHistory extends Component {
  render() {
    let items = this.props.set;
    let first = null;
    let last = 0;
    items.forEach((item, index) => {
      if (item.template && item.template.values && item.template.values.year) {
        if (first === null) first = index;
        last = index;
      }
    });

    return (
      <Wrapper>
        {items.map((item, index) => (
          <History
            key={item.id}
            content={item}
            first={index === first}
            last={index === last}
            line={index > first && index < last}
          />
        ))}
      </Wrapper>
    );
  }
}

const Item = styled.div`
  width: 100%;
  float: left;
  padding: 36px 0;
  position: relative;
  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 36, 23, "vw")} 0;
  }
  @media (max-width: 700px) {
    padding: 0;
    margin: 5px 0;
  }
`;

const Content = styled.div`
  width: 844px;
  padding: 0 calc(50% - 508px) 0 calc(50% - 336px);
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 1100px) {
    padding: 0 0 0 ${scale(1100, 767, 214, 165, "vw")};
    width: ${scale(1100, 767, 844, 589, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    float: left;
    padding: 0;

    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
  }
`;
const Image = styled.img`
  height: 280px;
  float: left;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 280, 200, "vw")};
  }
  @media (max-width: 700px) {
    max-height: 175px;
    max-width: 100%;
    height: 175px;
    width: auto;
  }
`;
const Text = styled.div`
  padding: 25px 40px;
  float: left;
  flex-grow: 1;
  flex-basis: 350px;

  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 25, 10, "vw")} ${scale(1100, 767, 40, 20, "vw")};
    flex-basis: ${scale(1100, 767, 350, 275, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 0;
  }
`;
const Title = styled.div`
  float: left;
  height: 27px;
  width: 100%;
  font-family: Lato;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: rgba(0, 0, 0, 0.85);

  padding-bottom: 8px;

  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 27, 24, "vw")};
    font-size: ${scale(1100, 767, 22, 20, "vw")};
    padding-bottom: ${scale(1100, 767, 8, 15, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.3px;
    text-align: center;
    width: 100%;
    margin: 20px 0 15px 0;
    padding: 0;
  }
`;
const Body = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.63;
  letter-spacing: 1.1px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 16, 12, "vw")};
    line-height: ${scale(1100, 767, 1.63 * 16, 1.75 * 12, "vw")};
    letter-spacing: ${scale(1100, 767, 1.1, 0.8, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 12px;
    line-height: 1.75;
    letter-spacing: 0.6px;
    text-align: center;
    width: 100%;
    margin: 0;
  }
`;
const Year = styled.div`
  width: 140px;
  height: 58px;
  font-family: Neuton;
  font-size: 50px;
  font-weight: 600;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.16;
  letter-spacing: 0.7px;
  text-align: center;
  color: #3949ab;

  padding: 3px 0 1px 0;
  position: absolute;
  left: calc(50% - 512px);
  top: 65px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1100px) {
    left: ${scale(1100, 767, 38, 25, "vw")};
    top: ${scale(1100, 767, 65, 45, "vw")};

    font-size: ${scale(1100, 767, 50, 30, "vw")};
    letter-spacing: ${scale(1100, 767, 0.7, 0.4, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    height: 38px;
    float: left;
    margin-bottom: 20px;

    position: relative;
    top: 0;
    left: 0;

    font-size: 30px;
    line-height: 1.16;
    letter-spacing: 0.4px;
  }
`;
const YearBackDrop = styled.div`
  width: 62px;
  height: 62px;
  background-color: #fff2dd;
  border-radius: 31px;

  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 62, 37, "vw")};
    height: ${scale(1100, 767, 62, 37, "vw")};
  }
  @media (max-width: 700px) {
    height: 38px;
    width: 38px;
    border-radius: 20px;
  }
`;
const YearDigits = styled.div`
  width: 100%;
  position: absolute;
  bottom: 8px;
  line-height: 1;
  left: 0;

  @media (max-width: 1100px) {
    bottom: ${scale(1100, 767, 8, 17, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    bottom: 8px;
  }
`;
const First = styled.div`
  position: absolute;
  left: calc(50% - 444px);
  top: 94px;
  border-left: solid 3px #3949ab;
  height: calc(100% - 94px);

  @media (max-width: 1100px) {
    left: ${scale(1100, 767, 106, 94, "vw")};
    border-left-width: ${scale(1100, 767, 3, 1.8, "vw")};

    top: ${scale(1100, 767, 94, 74, "vw")};
    height: ${scaleInverse(1100, 767, 94, 74, "vw")};
  }
  @media (max-width: 700px) {
    position: relative;
    width: 0;
    height: 0;
    top: 0;
    left: 0;
    border: 0 solid #fff;
  }
`;
const Last = styled.div`
  position: absolute;
  left: calc(50% - 444px);
  top: 0;
  border-left: solid 3px #3949ab;
  height: 94px;

  @media (max-width: 1100px) {
    left: ${scale(1100, 767, 106, 94, "vw")};
    border-left-width: ${scale(1100, 767, 3, 1.8, "vw")};

    height: ${scale(1100, 767, 94, 74, "vw")};
  }
  @media (max-width: 700px) {
    position: relative;
    width: 0;
    height: 0;
    top: 0;
    left: 0;
    border: 0 solid #fff;
  }
`;
const Line = styled.div`
  position: absolute;
  left: calc(50% - 444px);
  top: 0;
  border-left: solid 3px #3949ab;
  height: 100%;

  @media (max-width: 1100px) {
    left: ${scale(1100, 767, 106, 94, "vw")};
    border-left-width: ${scale(1100, 767, 3, 1.8, "vw")};
  }
  @media (max-width: 700px) {
    position: relative;
    width: 0;
    height: 0;
    top: 0;
    left: 0;
    border: 0 solid #fff;
  }
`;

class History extends Component {
  imageUrl = () => {
    if (this.props.content.images.intro) {
      return this.props.content.images.intro.url;
    }
    if (this.props.content.images.main) {
      return this.props.content.images.main.url;
    }
  };
  year = () => {
    if (
      this.props.content.template &&
      this.props.content.template.values &&
      this.props.content.template.values.year
    ) {
      return (
        <Year>
          <YearBackDrop />
          <YearDigits>{this.props.content.template.values.year}</YearDigits>
        </Year>
      );
    }
  };
  line = () => {
    if (this.props.first) return <First />;
    if (this.props.last) return <Last />;
    if (this.props.line) return <Line />;
  };
  render() {
    return (
      <Item>
        {this.line()}
        {this.year()}
        <Content>
          <Image src={this.imageUrl()} />
          <Text>
            <Title>{this.props.content.title}</Title>
            <Body
              dangerouslySetInnerHTML={{ __html: this.props.content.body }}
            />
          </Text>
        </Content>
      </Item>
    );
  }
}

export default SetHistory;



// WEBPACK FOOTER //
// ./src/components/SetHistory.js